import { formatTimeOfDay } from '@rundown-studio/timeutils'
import type { FC, HTMLAttributes } from 'react'
import { cn } from '@/utils'

interface GroupRangeProps extends HTMLAttributes<HTMLSpanElement> {
  start?: Date
  end?: Date
  timezone?: string | null
  separatorClassName?: string
  startClassName?: string
  endClassName?: string
  todDisplayFormat?: '24h' | '12hNoAmPm' | '12h' | null
}

export const GroupRange: FC<GroupRangeProps> = ({
  start,
  end,
  separatorClassName,
  startClassName,
  endClassName,
  todDisplayFormat = '24h',
  className,
  timezone = 'UTC',
  ...spanProps
}) => {
  if (!start || !end) return null

  const effectiveTimezone = timezone ?? 'UTC'

  const startTime = formatTimeOfDay(start, {
    format: todDisplayFormat,
    timezone: effectiveTimezone,
  })
  const endTime = formatTimeOfDay(end, {
    format: todDisplayFormat,
    timezone: effectiveTimezone,
  })

  return (
    <span className={cn('text-xs', className)} {...spanProps}>
      <span className={cn('tabular-nums', startClassName)}>{startTime}</span>{' '}
      <span className={separatorClassName}>→</span>{' '}
      <span className={cn('tabular-nums', endClassName)}>{endTime}</span>
    </span>
  )
}
